import api from '@/api/applicantStatusAutoChangeConfig'

const state = {

}

const actions = {
  getCompanyApplicantStatusAutoChangeConfig (context, data) {
    return api.getCompanyApplicantStatusAutoChangeConfig(data.companyId, data.params)
  },
  deleteApplicantStatusAutoChangeConfig (context, companyId) {
    return api.deleteApplicantStatusAutoChangeConfig(companyId)
  },
  createApplicantStatusAutoChangeConfig (context, { companyId, configList }) {
    return api.createApplicantStatusAutoChangeConfig(companyId, configList)
  },
  updateApplicantStatusAutoChangeConfig (context, { companyId, configList }) {
    return api.updateApplicantStatusAutoChangeConfig(companyId, configList)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
